// Événements Google Analytics du site vitrine. gtag n'est chargé qu'en production,
// sur www (voir server/utils/seo.ts) : ailleurs, ces appels ne font rien.

type Params = Record<string, string | number | undefined>;

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

export function track(name: string, params: Params = {}) {
  window.gtag?.('event', name, params);
}

// Même chose avant de quitter la page (redirection) : on attend que l'événement
// soit parti, 800 ms au plus.
export function trackThen(name: string, params: Params, next: () => void) {
  if (!window.gtag) return next();
  let done = false;
  const go = () => {
    if (done) return;
    done = true;
    next();
  };
  window.gtag('event', name, { ...params, transport_type: 'beacon', event_callback: go });
  setTimeout(go, 800);
}

// Page d'où vient l'inscription : retenue au clic sur un bouton d'inscription,
// pour la joindre ensuite à l'événement sign_up.
const SOURCE_KEY = 'signupSource';

export function signupSource(): string {
  try {
    return sessionStorage.getItem(SOURCE_KEY) ?? 'direct';
  } catch {
    return 'direct';
  }
}

// Emplacement d'un bouton d'inscription dans la page
function ctaLocation(a: HTMLElement): string {
  if (a.closest('header')) return 'header';
  if (a.closest('footer')) return 'footer';
  if (a.closest('.mk-fixed-cta')) return 'fixed';
  if (a.closest('.mk-cta-row')) return 'hero';
  if (a.closest('.mg-cta-box')) return 'article';
  if (a.closest('.mk-cta')) return 'band';
  return 'page';
}

// Tous les liens vers /signup, où qu'ils soient : un seul écouteur sur la page.
// Renvoie la fonction qui le retire.
export function trackSignupClicks(): () => void {
  const onClick = (e: MouseEvent) => {
    const a = (e.target as HTMLElement | null)?.closest<HTMLAnchorElement>('a[href]');
    if (!a) return;
    const url = new URL(a.href, window.location.href);
    if (url.origin !== window.location.origin || url.pathname !== '/signup') return;
    const page = window.location.pathname;
    try {
      sessionStorage.setItem(SOURCE_KEY, page);
    } catch {}
    track('signup_cta_click', {
      page_path: page,
      cta_location: ctaLocation(a),
      cta_text: a.textContent?.trim().slice(0, 60),
      start_intent: url.searchParams.get('start') ?? undefined,
    });
  };
  document.addEventListener('click', onClick, true);
  return () => document.removeEventListener('click', onClick, true);
}
